export const ptContent = {
  introduction: {
    content: [
      "Desde sua estreia em 1996, a série Pokémon conquistou corações em todo o mundo, tornando-se uma das marcas de entretenimento mais amadas globalmente. Nosso Gerador Aleatório de Pokémon foi projetado para treinadores de todas as idades que desejam descobrir novos Pokémon, construir equipes equilibradas ou simplesmente desfrutar do elemento surpresa em sua jornada Pokémon.",
      "Seja você um treinador experiente em busca de inspiração para sua próxima equipe de torneio ou um fã casual que deseja expandir sua Pokédex, esta ferramenta de Randomização de Pokémon oferece uma maneira divertida e interativa de explorar o vasto mundo Pokémon."
    ]
  },
  howToUse: {
    content: [
      "Usar nosso Seletor Aleatório de Pokémon é simples e intuitivo. Siga estes passos para começar a gerar sua equipe Pokémon perfeita:",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "Selecione o número de Pokémon: Escolha quantos Pokémon você deseja gerar (1-8)." },
          { type: "text", content: "Escolha um Tipo: Filtre por tipos específicos como Fogo, Água, Elétrico, ou selecione \"Qualquer\" para incluir todos os tipos." },
          { type: "text", content: "Selecione uma Geração: Escolha da Geração I até a VIII, ou selecione \"Qualquer\" para incluir Pokémon de todas as gerações." },
          { type: "text", content: "Defina preferências de Raridade: Determine quão raros você quer que seus Pokémon gerados sejam." },
          { type: "text", content: "Clique em \"Gerar\": Depois de definir suas preferências, clique no botão para gerar Pokémon que correspondam aos seus critérios." },
          { type: "text", content: "Explore os Resultados: Revise as informações detalhadas de cada Pokémon, incluindo estatísticas, habilidades, tipos e mais!" }
        ]
      },
      "Você pode repetir este processo quantas vezes quiser, ajustando seus parâmetros para descobrir diferentes combinações de Pokémon."
    ]
  },
  benefits: {
    content: [
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Completamente Gratuito: Nosso Gerador Aleatório de Pokémon é 100% gratuito, sem taxas ocultas ou assinaturas." },
          { type: "text", content: "Experiência Personalizável: Filtre por tipo, geração e raridade para personalizar suas seleções aleatórias." },
          { type: "text", content: "Ferramenta Educativa: Aprenda sobre diferentes espécies de Pokémon, suas estatísticas, habilidades e tipos." },
          { type: "text", content: "Montagem de Equipe: Gere rapidamente equipes equilibradas para jogo casual ou batalhas competitivas." },
          { type: "text", content: "Criador de Desafios: Crie desafios únicos limitando-se a Pokémon gerados aleatoriamente." },
          { type: "text", content: "Sem Conta Necessária: Use a ferramenta instantaneamente sem cadastros ou informações pessoais." }
        ]
      }
    ]
  },
  history: {
    content: [
      "A franquia Pokémon começou em 1996 quando Satoshi Tajiri criou os primeiros jogos Pokémon para o Game Boy da Nintendo. Inspirado em seu hobby de infância de colecionar insetos, o conceito centrou-se em capturar, treinar e batalhar com criaturas chamadas \"Pocket Monsters\" ou Pokémon.",
      "Marcos importantes na história do Pokémon:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "1996: Lançamento de Pokémon Vermelho e Verde no Japão" },
          { type: "text", content: "1998: Lançamento internacional de Pokémon Vermelho e Azul" },
          { type: "text", content: "1999: Lançamento mundial do Jogo de Cartas Colecionáveis Pokémon" },
          { type: "text", content: "2000: Introdução de Ouro e Prata, adicionando 100 novos Pokémon" },
          { type: "text", content: "2016: Lançamento de Pokémon GO, trazendo a franquia para plataformas móveis" },
          { type: "text", content: "2019: Estreia de Pokémon Espada e Escudo no Nintendo Switch" }
        ]
      },
      "Hoje, com mais de 900 espécies diferentes de Pokémon ao longo de oito gerações, a franquia expandiu-se para incluir videogames, cartas colecionáveis, séries animadas, filmes, mercadorias e aplicativos móveis, tornando-se uma das franquias de mídia mais lucrativas de todos os tempos."
    ]
  },
  popularPokemon: {
    content: [
      "Ao longo da história do Pokémon, várias espécies se tornaram símbolos icônicos da franquia:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pikachu: O mascote do tipo Elétrico da franquia, conhecido por sua cauda em forma de raio e bochechas rosadas." },
          { type: "text", content: "Charizard: Um favorito dos fãs do tipo Fogo/Voador conhecido por sua aparência semelhante a um dragão e habilidades poderosas." },
          { type: "text", content: "Mewtwo: Um lendário do tipo Psíquico criado através da manipulação genética de Mew, conhecido por seu imenso poder." },
          { type: "text", content: "Eevee: Amado por sua capacidade única de evoluir em diferentes tipos, incluindo Vaporeon, Jolteon e Flareon." },
          { type: "text", content: "Gyarados: Um temível tipo Água/Voador que evolui do humilde Magikarp." },
          { type: "text", content: "Lucario: Um tipo Lutador/Aço conhecido por suas habilidades de aura e popularidade no jogo competitivo." },
          { type: "text", content: "Greninja: Um Pokémon sapo ninja do tipo Água/Noturno que ganhou popularidade através da série animada." }
        ]
      },
      "Nosso Gerador Aleatório de Pokémon dá a você a chance de descobrir essas criaturas icônicas e muitas outras espécies menos conhecidas, mas igualmente fascinantes."
    ]
  },
  popularGames: {
    content: [
      "A série de jogos Pokémon produziu numerosos títulos amados em várias plataformas:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pokémon Vermelho, Azul e Amarelo: Os jogos originais que iniciaram o fenômeno no Game Boy." },
          { type: "text", content: "Pokémon Ouro, Prata e Cristal: Introduziram a região de Johto e ciclos de dia/noite." },
          { type: "text", content: "Pokémon Rubi, Safira e Esmeralda: Expandiram o mundo com a região de Hoenn e batalhas duplas." },
          { type: "text", content: "Pokémon Diamante, Pérola e Platina: Trouxeram a série para o Nintendo DS com funcionalidade online." },
          { type: "text", content: "Pokémon Preto e Branco: Apresentaram um conjunto totalmente novo de Pokémon e uma abordagem mais focada na história." },
          { type: "text", content: "Pokémon X e Y: Introduziram modelos 3D e Mega Evolução." },
          { type: "text", content: "Pokémon Sol e Lua: Reinventaram o sistema de ginásios com as Provas das Ilhas." },
          { type: "text", content: "Pokémon GO: O jogo de realidade aumentada móvel que se tornou um fenômeno global." },
          { type: "text", content: "Pokémon Espada e Escudo: Trouxeram a série para o Nintendo Switch com o conceito da Área Selvagem." },
          { type: "text", content: "Lendas Pokémon: Arceus: Uma nova abordagem de mundo aberto para a série." }
        ]
      },
      "Cada jogo introduz novas mecânicas e Pokémon, expandindo o universo que nosso Gerador Aleatório de Pokémon ajuda você a explorar."
    ]
  },
  tradingContests: {
    content: [
      "A troca de Pokémon tem sido um aspecto fundamental da franquia desde seu início. Os jogos originais foram lançados em pares especificamente para incentivar os jogadores a trocarem com amigos para completar sua Pokédex. Este elemento social ajudou a espalhar a popularidade do Pokémon e continua importante hoje.",
      "Aspectos principais da troca:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pokémon exclusivos de versão que só podem ser obtidos através de trocas" },
          { type: "text", content: "Evoluções por troca para certas espécies como Machoke e Kadabra" },
          { type: "text", content: "Sistemas de Troca Global em jogos modernos permitindo trocas mundiais" },
          { type: "text", content: "Troca de Pokémon raros ou shiny como símbolos de status" }
        ]
      },
      "Os Concursos Pokémon, introduzidos na Geração III, oferecem uma alternativa às batalhas onde os Pokémon competem com base em aparência, performance e apelo em vez de força. Estes concursos incluem:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Diferentes categorias de concurso (Carisma, Beleza, Fofura, Inteligência, Dureza)" },
          { type: "text", content: "Movimentos especiais projetados especificamente para concursos" },
          { type: "text", content: "Gerenciamento da condição do Pokémon através de bagas e pokéblocos" },
          { type: "text", content: "Competições em múltiplos estágios com julgamentos visuais preliminares e rodadas de apresentação" }
        ]
      },
      "Nosso Gerador Aleatório de Pokémon pode ajudar você a descobrir Pokémon que poderiam se destacar em concursos ou se tornar valiosos parceiros de troca, adicionando outra dimensão à sua experiência Pokémon."
    ]
  },
  faq: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "Este Gerador Aleatório de Pokémon é gratuito?",
            answer: "Sim, nossa ferramenta é completamente gratuita sem custos ocultos ou requisitos de assinatura."
          },
          {
            type: "faq",
            question: "Quão precisos são os dados dos Pokémon?",
            answer: "Todos os dados são provenientes da PokéAPI oficial, garantindo precisão e informações atualizadas."
          },
          {
            type: "faq",
            question: "Posso gerar Pokémon de uma geração específica?",
            answer: "Sim, você pode filtrar por geração de I até VIII, ou escolher \"Qualquer\" para incluir todas as gerações."
          },
          {
            type: "faq",
            question: "Como funciona o filtro de raridade?",
            answer: "Nosso algoritmo atribui valores de raridade baseados em fatores como status lendário/mítico, experiência base e outros atributos para criar uma escala de raridade de 1 a 10."
          },
          {
            type: "faq",
            question: "Posso salvar ou exportar os Pokémon gerados?",
            answer: "Atualmente, você pode tirar capturas de tela dos seus resultados. Estamos considerando adicionar funcionalidade de salvar/exportar em atualizações futuras."
          },
          {
            type: "faq",
            question: "O Gerador Aleatório de Pokémon é compatível com dispositivos móveis?",
            answer: "Sim, nosso gerador é totalmente responsivo e funciona em smartphones, tablets e computadores desktop."
          }
        ]
      }
    ]
  },
  conclusion: {
    content: [
      "Nosso Gerador Aleatório de Pokémon oferece possibilidades infinitas tanto para fãs casuais quanto para treinadores dedicados. Seja você procurando descobrir novos favoritos, criar equipes temáticas ou se desafiar com combinações inesperadas, nossa ferramenta fornece uma maneira divertida e educativa de explorar o vasto mundo dos Pokémon.",
      "Estamos constantemente trabalhando para melhorar o gerador com novos recursos e opções. Experimente hoje definindo suas preferências e clicando em \"Gerar\" para ver quais Pokémon esperam por você!",
      "Compartilhe seus resultados com amigos e outros treinadores, e nos conte como você está usando o Gerador Aleatório de Pokémon em sua jornada Pokémon. Boa caçada!"
    ]
  }
}; 